import { render, staticRenderFns } from "./ErrorStore.vue?vue&type=template&id=1aa87a3e&"
import script from "./ErrorStore.vue?vue&type=script&lang=js&"
export * from "./ErrorStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports